<template>
  <div class="bbe-font-size" v-click-outside="close">
    <div class="bbe-font-size__item"
         v-for="size in fontSizeOptions"
         @click="setSize(size)"
         :key="size">
      {{size}}
    </div>
  </div>
</template>

<script>
import fontSizes from '@/constants/toolbarEditorOptions/fontSizes'

export default {
  name: 'FontSizeSelect',
  data () {
    return {
      fontSizeOptions: fontSizes
    }
  },
  methods: {
    setSize (size) {
      this.$emit('set', size)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbe-font-size {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: $color-white;
    min-width: 50px;
    padding: 6px 0;
    width: 100%;

    &__item {
      text-align: center;
      width: 100%;
      padding: 6px 12px;
      font-size: 13px;
      transition: 0.3s;

      &:hover {
        background-color: $color-gallery;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/TextEditor/FontSizeSelect/FontSizeSelect.vue